import { render, staticRenderFns } from "./VendaPedidoLista.vue?vue&type=template&id=7cb0cf41&scoped=true"
import script from "./VendaPedidoLista.vue?vue&type=script&lang=js"
export * from "./VendaPedidoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0cf41",
  null
  
)

export default component.exports